import { Popup } from "react-map-gl";

interface IMapPopup {
    show: boolean,
    latitude: number;
    longitude: number;
    children: React.ReactNode;
    onClose?: () => void;
}

const MapPopup = ({show, latitude, longitude, children, onClose}: IMapPopup) => {
    return (
    <>
      {show && (
        <Popup
          latitude={latitude}
          longitude={longitude}
          closeButton={true}
          closeOnClick={false}
          onClose={onClose}
          anchor="bottom" >
          { children }
        </Popup>
      )}    
    </>
    )  
} 

export default MapPopup;